import { ServiceCard } from '../../../../../features/services/components/ServiceCard';
import { useI18n } from '../../../../../shared/i18n';
import { useData } from '../../../../../shared/lib';
import { Container, EmptyState, Eyebrow, Grid, Section } from '../../../../../shared/ui';
import type { ServicesListingData } from './+data';

export default function Page() {
  const { t } = useI18n();
  const { services, icons } = useData<ServicesListingData>();

  return (
    <Section spacing="lg">
      <Container className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          {/* A route, not a translated label: it stays Latin and LTR in
              Arabic too, same as any other URL-shaped token (SerpPreview
              does the same for the same reason). */}
          <Eyebrow>
            <span dir="ltr">/services</span>
          </Eyebrow>
          <h1 className="max-w-2xl text-4xl font-bold tracking-tight sm:text-5xl">
            {t('nav.primary.services')}
          </h1>
        </div>

        {services.length > 0 ? (
          <Grid columns={3}>
            {services.map((service) => (
              <ServiceCard
                key={service.id}
                service={service}
                icon={service.icon_media_id ? icons[service.icon_media_id] : undefined}
              />
            ))}
          </Grid>
        ) : (
          <EmptyState
            title={t('common.services.emptyTitle')}
            description={t('common.services.emptyDescription')}
          />
        )}
      </Container>
    </Section>
  );
}
